import { clsx } from 'clsx';
import { FC } from 'react';

import { IconArrowRight } from 'src/general/Icons/IconArrowRight';
import { Link } from 'src/general/components/Link/Link';
import { Shade } from 'src/general/components/Shade/Shade';

import { getFilter } from './RecentSearch.helper';
import { RecentFilterSearch } from './RecentSearch.type';

type RecentSearchProps = RecentFilterSearch & {
  className?: string;
  onClick: () => void;
};

export const RecentSearch: FC<RecentSearchProps> = (props) => {
  const search = getFilter({ ...props });

  return (
    <Link
      href={props.url}
      className={clsx(
        'c-shade_container c-shade_container--grey relative flex items-center justify-between gap-2 overflow-hidden rounded-2xl border-0 p-4 no-underline shadow-sm',
        props.className,
      )}
      onClick={props.onClick}
      data-testid={`recent-search-${props.id}`}
    >
      <Shade noBackground />
      <div className="pointer-events-none grid">
        <div
          className="c-fs-body1 max-w-full overflow-hidden font-extrabold text-ellipsis whitespace-nowrap text-tex-def-tie1 capitalize"
          data-testid={`recent-search-key-${typeof search.title === 'string' ? search.title : props.id}`}
        >
          {search.title}
        </div>
        {search.caption && (
          <div
            className="c-fs-caption2 max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-tex-def-tie3"
            data-testid={`recent-search-subtitle-${typeof search.title === 'string' ? search.title : props.id}`}
          >
            {search.caption}
          </div>
        )}
      </div>
      <IconArrowRight />
    </Link>
  );
};
